<script lang="ts">
export const elIconColors = [
  'pink',
  'yellow',
  'orange',
  'cyan',
  'rose',
  'green',
  'brand-blue',
  'brand-green',
  'red',
  'purple',
  'indigo',
] as const;
type ElIconColors = (typeof elIconColors)[number];
export type IconNames = keyof typeof outlineIcons | ElIconColors;
export type ElIconProps = {
  name: IconNames;
  color?: ElIconColors;
  solid?: boolean;
  cursorPointer?: boolean;
  disabled?: boolean;
};
</script>

<script lang="ts" setup>
import * as outlineIcons from '@heroicons/vue/24/outline';
import * as solidIcons from '@heroicons/vue/24/solid';
import { computed } from 'vue';

const props = defineProps<{
  name: IconNames;
  color?: ElIconColors;
  solid?: boolean;
  disabled?: boolean;
}>();

// Deprecated: this stuff is a mess, don't pass color as the name
const isColorDot = computed(() => isElIconColor(props.name));
function isElIconColor(color: string): color is ElIconColors {
  return elIconColors.includes(color as ElIconColors);
}

const iconComponent = computed(() => {
  if (isElIconColor(props.name)) return;
  return props.solid ? solidIcons[props.name] : outlineIcons[props.name];
});
</script>

<template>
  <div
    v-if="isColorDot"
    class="h-4 w-4 rounded-full"
    :class="{
      'bg-yellow-500': name === 'yellow',
      'bg-orange-500': name === 'orange',
      'bg-cyan-500': name === 'cyan',
      'bg-rose-500': name === 'rose',
      'bg-green-500': name === 'green',
      'bg-brandBlue-500': name === 'brand-blue',
      'bg-brandGreen-500': name === 'brand-green',
      'bg-red-500': name === 'red',
      'bg-purple-500': name === 'purple',
      'bg-indigo-500': name === 'indigo',
    }"
  ></div>
  <component
    :is="iconComponent"
    v-else
    :class="{
      'text-yellow-500': color === 'yellow',
      'text-orange-500': color === 'orange',
      'text-cyan-500': color === 'cyan',
      'text-rose-500': color === 'rose',
      'text-green-500': color === 'green',
      'text-brandBlue-500': color === 'brand-blue',
      'text-brandGreen-500': color === 'brand-green',
      'text-red-500': color === 'red',
      'text-purple-500': color === 'purple',
      'text-indigo-500': color === 'indigo',
    }"
  />
</template>
